// extracted by mini-css-extract-plugin
export default {"fabShippingAddressButton":"registry-page-guest__fabShippingAddressButton__DrPIR"};